/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../utils/constants';

const IDS = {
  HELMET_ADDLOAN_PAGETITLE: 'settings.helmet.addLoan.pageTitle',
  HELMET_ADDLOAN_PAGETITLE_CONFIRMATION: 'settings.helmet.addLoan.pageTitle.confirmation',
  HELMET_CHANGEEMAIL_PAGETITLE: 'settings.helmet.changeEmail.pageTitle',
  HELMET_CHANGEEMAIL_PAGETITLE_CONFIRMATION: 'settings.helmet.changeEmail.pageTitle.confirmation',
  HELMET_CHANGEMAILINGADDRESS_PAGETITLE: 'settings.helmet.changeMailingAddress.pageTitle',
  HELMET_CHANGEMAILINGADDRESS_PAGETITLE_CONFIRMATION: 'settings.helmet.changeMailingAddress.changeMailingAddress.pageTitle.confirmation',
  HELMET_CHANGEMAILINGADDRESS_PAGETITLE_ERROR: 'settings.helmet.changeMailingAddress.pageTitle.error',
  HELMET_CHANGEMAILINGADDRESS_PAGETITLE_UPLOAD: 'settings.helmet.changeMailingAddress.pageTitle.upload',
  HELMET_CHANGEMOBILENUMBER_PAGETITLE: 'settings.helmet.changeMobileNumber.pageTitle',
  HELMET_CHANGEMOBILENUMBER_PAGETITLE_CONFIRMATION: 'settings.helmet.changeMobileNumber.pageTitle.confirmation',
  HELMET_EDITLEGALNAME_PAGETITLE: 'settings.helmet.editLegalName.pageTitle',
  HELMET_EDITLEGALNAME_PAGETITLE_CONFIRMATION: 'settings.helmet.editLegalName.pageTitle.confirmation',
  HELMET_EDITLEGALNAME_PAGETITLE_ERROR: 'settings.helmet.editLegalName.pageTitle.error',
  HELMET_EDITLEGALNAME_PAGETITLE_UPLOAD: 'settings.helmet.editLegalName.pageTitle.upload',
  HELMET_EDITMILITARYSTATUS_PAGETITLE: 'settings.helmet.editMilitaryStatus.pageTitle',
  HELMET_EDITMILITARYSTATUS_PAGETITLE_CONFIRMATION: 'settings.helmet.editMilitaryStatus.pageTitle.confirmation',
  HELMET_EDITMILITARYSTATUS_PAGETITLE_ERROR: 'settings.helmet.editMilitaryStatus.pageTitle.error',
  HELMET_EDITMILITARYSTATUS_PAGETITLE_UPLOAD: 'settings.helmet.editMilitaryStatus.pageTitle.upload',
  HELMET_EDITPASSWORD_PAGETITLE: 'settings.helmet.editPassword.pageTitle',
  HELMET_EDITPASSWORD_PAGETITLE_CONFIRMATION: 'settings.helmet.editPassword.pageTitle.confirmation',
  HELMET_EDITPASSWORD_PAGETITLE_ERROR: 'settings.helmet.editPassword.pageTitle.error',
  HELMET_NOTIFICATIONS_PAGETITLE: 'settings.helmet.notifications.pageTitle',
  HELMET_NOTIFICATIONS_PAGETITLE_CONFIRMATION: 'settings.helmet.notifications.pageTitle.confirmation',
  HELMET_NOTIFICATIONS_PAGETITLE_ERROR: 'settings.helmet.notifications.pageTitle.error',
  HELMET_PAPERLESS_PAGETITLE: 'settings.helmet.paperless.pageTitle',
  HELMET_PAPERLESS_PAGETITLE_CONFIRMATION: 'settings.helmet.paperless.pageTitle.confirmation',
  HELMET_PAPERLESS_PAGETITLE_ERROR: 'settings.helmet.paperless.pageTitle.error',
  HELMET_PAPERLESS_PAGETITLE_TERMS_AND_CONDITIONS: 'settings.helmet.paperless.pageTitle.termsAndConditions',
  HELMET_SECTIONTITLE_COMMUNICATIONS: 'settings.helmet.sectionTitle.communications',
  HELMET_SECTIONTITLE_PROFILE: 'settings.helmet.sectionTitle.profile',
};

const enMessages = {
  [IDS.HELMET_ADDLOAN_PAGETITLE]: 'Add New Loan',
  [IDS.HELMET_ADDLOAN_PAGETITLE_CONFIRMATION]: 'Add New Loan Confirmation',
  [IDS.HELMET_CHANGEEMAIL_PAGETITLE]: 'Edit Email Address',
  [IDS.HELMET_CHANGEEMAIL_PAGETITLE_CONFIRMATION]: 'Edit Email Address Confirmation',
  [IDS.HELMET_CHANGEMAILINGADDRESS_PAGETITLE]: 'Edit Mailing Address',
  [IDS.HELMET_CHANGEMAILINGADDRESS_PAGETITLE_CONFIRMATION]: 'Edit Mailing Address Confirmation',
  [IDS.HELMET_CHANGEMAILINGADDRESS_PAGETITLE_ERROR]: 'Edit Mailing Address Error',
  [IDS.HELMET_CHANGEMAILINGADDRESS_PAGETITLE_UPLOAD]: 'Upload Mailing Address Document',
  [IDS.HELMET_CHANGEMOBILENUMBER_PAGETITLE]: 'Edit Mobile Number',
  [IDS.HELMET_CHANGEMOBILENUMBER_PAGETITLE_CONFIRMATION]: 'Edit Mobile Number Confirmation',
  [IDS.HELMET_EDITLEGALNAME_PAGETITLE]: 'Edit Legal Name',
  [IDS.HELMET_EDITLEGALNAME_PAGETITLE_CONFIRMATION]: 'Edit Legal Name Confirmation',
  [IDS.HELMET_EDITLEGALNAME_PAGETITLE_ERROR]: 'Edit Legal Name Error',
  [IDS.HELMET_EDITLEGALNAME_PAGETITLE_UPLOAD]: 'Upload Legal Name Document',
  [IDS.HELMET_EDITMILITARYSTATUS_PAGETITLE]: 'Edit Military Status',
  [IDS.HELMET_EDITMILITARYSTATUS_PAGETITLE_CONFIRMATION]: 'Edit Military Status Confirmation',
  [IDS.HELMET_EDITMILITARYSTATUS_PAGETITLE_ERROR]: 'Edit Military Status Error',
  [IDS.HELMET_EDITMILITARYSTATUS_PAGETITLE_UPLOAD]: 'Upload Military Status Document',
  [IDS.HELMET_EDITPASSWORD_PAGETITLE]: 'Edit Password',
  [IDS.HELMET_EDITPASSWORD_PAGETITLE_CONFIRMATION]: 'Edit Password Confirmation',
  [IDS.HELMET_EDITPASSWORD_PAGETITLE_ERROR]: 'Edit Password Error',
  [IDS.HELMET_NOTIFICATIONS_PAGETITLE]: 'Text and Email Notifications',
  [IDS.HELMET_NOTIFICATIONS_PAGETITLE_CONFIRMATION]: 'Confirmation',
  [IDS.HELMET_NOTIFICATIONS_PAGETITLE_ERROR]: 'Text and Email Notifications Error',
  [IDS.HELMET_PAPERLESS_PAGETITLE]: 'Paperless Billing',
  [IDS.HELMET_PAPERLESS_PAGETITLE_CONFIRMATION]: 'Paperless Billing Confirmation',
  [IDS.HELMET_PAPERLESS_PAGETITLE_ERROR]: 'Paperless Billing Error',
  [IDS.HELMET_PAPERLESS_PAGETITLE_TERMS_AND_CONDITIONS]: 'Paperless Terms and Conditions',
  [IDS.HELMET_SECTIONTITLE_COMMUNICATIONS]: 'Settings',
  [IDS.HELMET_SECTIONTITLE_PROFILE]: 'Settings',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.HELMET_ADDLOAN_PAGETITLE]: 'Add New Account',
  [IDS.HELMET_ADDLOAN_PAGETITLE_CONFIRMATION]: 'Add New Account Confirmation',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
